module.exports = {
    publicPath:'/',
    // api:'http://reliao-dev.qiyi.domain',
    // shareUrl:'http://hotchat-oa.iqiyi.com/static/information-station/#/detail?id=${id}'
};


// WEBPACK FOOTER //
// config/dev.js